<div style="margin: 5px 3px">
    <div *ngIf="IsEmpty === true">
        <ng-content select="upp-grid-empty"></ng-content>
    </div>
    <div *ngIf="IsEmpty !== true">
        <div [ngClass]="{ 'thumbnail-grid': ViewMode === 'GRID', 'thumbnail-list': ViewMode === 'LIST' }" [style.transform]="size === 'LARGE' ? 'none' : ('scale(' + ScaleMode + ')')">
            <ng-content></ng-content>
        </div>
    </div>
</div>